import axios from "axios";
import Vue from "vue";
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true;
import router from "../router/routerMap";
// 配置API接口地址
//
//
let baseApi = "https://www.wha518.com/api/v2/"; // 开发服务器

Vue.prototype.baseUrl = baseApi;
let that = this;
export default class Axios {
  static ajax(options) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common["authorization"] =
       sessionStorage.getItem("token");
      axios({
          url: options.url,
          method: options.method || "POST",
          baseURL: baseApi,
          timeout: 80000,
          data:
            options.method.toUpperCase() == "POST" ||
            options.method.toUpperCase() == "PUT"
              ? options.data
              : null,
          params:
            options.method.toUpperCase() == "GET" ||
            options.method.toUpperCase() == "DELETE"
              ? options.params
              : null,
        },
        {
          headers: options.headers,
        }
      ).then((response) => {
        if (response.data.resultCode == "401") {
          Vue.prototype.$message({
            type: "error",
            message: "登录过期",
          });
          router.push("/newlogin");
        }
        if (response.data.code == -1 && options.url != "/sys/getLogin") {
          Vue.prototype.$message({
            message: response.data.msg,
            type: "warning",
            showClose: true,
          });
        }
        if (response.status == 200) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      });
    });
  }
}
